module.exports = __webpack_public_path__ + "img/aeronautica_roma_hero_card.a8b14a6f.png";